import { render, staticRenderFns } from "./DiagnosiIcdIxComponent.vue?vue&type=template&id=ea8eac74"
import script from "./DiagnosiIcdIxComponent.vue?vue&type=script&lang=js"
export * from "./DiagnosiIcdIxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports